export function createUploadProgressHandler(): UploadProgressHandler {
    let subs: ProgressChangedHandler[] = [];
    
	return {
	    handleUploadProgress: progress => {
	        subs.forEach(s => s(progress));
        },
        subscribe: handler => {
	        subs.push(handler);
	        
	        return () => {
	            subs = subs.filter(s => s !== handler);
            }
        }
    }
}

export interface UploadProgressHandler extends UploadProgressNotifier {
    handleUploadProgress: (progress: number) => void;
}

export interface UploadProgressNotifier {
    /**
     * subscribes to progress events and returns
     * a de-registration function
     */
    subscribe: (handler: ProgressChangedHandler) => (() => void);
}

type ProgressChangedHandler = (percent: number) => void;